"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesDetailsByPriceItem$ = exports.SalesDetailsByPriceItem$outboundSchema = exports.SalesDetailsByPriceItem$inboundSchema = void 0;
exports.salesDetailsByPriceItemToJSON = salesDetailsByPriceItemToJSON;
exports.salesDetailsByPriceItemFromJSON = salesDetailsByPriceItemFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.SalesDetailsByPriceItem$inboundSchema = z.object({
    count_of_sales: z.number().int(),
    price_bracket_index: z.number().int(),
    price_bracket_name: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "count_of_sales": "countOfSales",
        "price_bracket_index": "priceBracketIndex",
        "price_bracket_name": "priceBracketName",
    });
});
/** @internal */
exports.SalesDetailsByPriceItem$outboundSchema = z.object({
    countOfSales: z.number().int(),
    priceBracketIndex: z.number().int(),
    priceBracketName: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        countOfSales: "count_of_sales",
        priceBracketIndex: "price_bracket_index",
        priceBracketName: "price_bracket_name",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var SalesDetailsByPriceItem$;
(function (SalesDetailsByPriceItem$) {
    /** @deprecated use `SalesDetailsByPriceItem$inboundSchema` instead. */
    SalesDetailsByPriceItem$.inboundSchema = exports.SalesDetailsByPriceItem$inboundSchema;
    /** @deprecated use `SalesDetailsByPriceItem$outboundSchema` instead. */
    SalesDetailsByPriceItem$.outboundSchema = exports.SalesDetailsByPriceItem$outboundSchema;
})(SalesDetailsByPriceItem$ || (exports.SalesDetailsByPriceItem$ = SalesDetailsByPriceItem$ = {}));
function salesDetailsByPriceItemToJSON(salesDetailsByPriceItem) {
    return JSON.stringify(exports.SalesDetailsByPriceItem$outboundSchema.parse(salesDetailsByPriceItem));
}
function salesDetailsByPriceItemFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.SalesDetailsByPriceItem$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'SalesDetailsByPriceItem' from JSON`);
}
//# sourceMappingURL=salesdetailsbypriceitem.js.map